import { Injectable } from '@angular/core';
import { utcToZonedTime } from 'date-fns-tz';
import { environment } from '../../../../environments/environment';
import isWithinInterval from 'date-fns/isWithinInterval';

@Injectable({
  providedIn: 'root'
})
export class DateService {
  monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  constructor() {}

  static showPlannedMaintenance() {
    /*
    Show maintenance on:
    * - 07.12.2021 between 8:00AM and 08:30AM
    * - 08.12.2021 between 5:00AM and 05:30AM
    * */
    const now = new Date();
    return (
      environment.maintenance ||
      isWithinInterval(now, {
        start: new Date(2021, 11, 7, 8, 0),
        end: new Date(2021, 11, 7, 8, 30)
      }) ||
      isWithinInterval(now, {
        start: new Date(2021, 11, 8, 5, 0),
        end: new Date(2021, 11, 8, 5, 30)
      })
    );
  }

  // MMM D
  formatDateForHeroPlaceholder(date: string) {
    if (!date) {
      return '';
    }
    const dateArray = date.split('-');
    const monthIndex = parseInt(dateArray[1]) - 1;
    const day = dateArray[2];

    return `${this.monthNames[monthIndex].substr(0, 3)} ${day}`;
  }

  // YYYY-MM-DD
  formatDateForQuery(date: Date) {
    const day = date.getDate();
    const monthNumber = date.getMonth() + 1;
    const year = date.getFullYear();

    const dayToString = ('0' + day).slice(-2);
    const monthToString = ('0' + monthNumber).slice(-2);

    return year + '-' + monthToString + '-' + dayToString;
  }
  // Get CET time for check-in/out
  getCETime(dateTime: string) {
    return utcToZonedTime(dateTime || 0, 'Europe/Berlin');
  }
}
